/**
 * WYGLĄD INTERFEJSU ZAPISANY NA KONCIE (kolor akcentu, czcionka, motyw jasny/ciemny).
 *
 * Osobne wejście HTTP, bo `api/apiService.js` należy do równoległej fali prac — nowe metody
 * dopisujemy obok, przy module, który z nich korzysta. Instancja axiosa jest wspólna
 * (`apiService.api`): ten sam nagłówek autoryzacji, ta sama obsługa 401.
 *
 * Wszystkie wywołania są BEST-EFFORT: gdy serwer nie odpowie, aplikacja ma działać dalej na tym,
 * co zostało w localStorage. Wygląd nie może być powodem, dla którego ktoś nie wejdzie do pracy.
 *
 * [2026-10-03] Instancję bierzemy W CHWILI WYWOŁANIA, nie przy imporcie modułu. Okno „Wygląd aplikacji”
 * siedzi w powłoce (Layout), a zapadki powłoki podmieniają `apiService` atrapą bez `api` — odczyt przy
 * imporcie wywracał cały plik testu, zanim cokolwiek się wyrenderowało.
 */
import apiService from "./apiService";

const http = () => apiService.api;

const uiPreferencesApi = {
    /** @returns {Promise<{data:{preferences: Record<string,string>}}>} */
    pobierz: () => http().get("/user-preferences"),

    /** Zapisuje CAŁY zestaw (serwer odrzuca klucze spoza białej listy, a znaczniki konta przenosi sam). */
    zapisz: (preferences) => http().put("/user-preferences", preferences),

    /**
     * [2026-10-03] Okno „Wygląd aplikacji” zostało zamknięte — znacznik na KONCIE (raz na konto, nie raz
     * na przeglądarkę). Serwer zapisuje go wyłącznie zalogowanemu i przenosi przy każdym PUT wyżej.
     * @returns {Promise<{data:{preferences: Record<string,string>}}>}
     */
    oznaczOknoWygladu: () => http().post("/user-preferences/okno-wygladu"),

    // ── [BA-4 2026-09-18] Ukryte kolumny tabeli NA KONCIE („by po odświeżeniu nie musiał robić tego 2gi raz”) ──
    /** @returns {Promise<{data:{ekran:string, ukryteKolumny:string[]}}>} */
    pobierzKolumny: (ekran) => http().get(`/user-preferences/tabele/${encodeURIComponent(ekran)}`),
    /** Cała lista ukrytych kolumn (pusta = wszystko widoczne). */
    zapiszKolumny: (ekran, ukryteKolumny) =>
        http().put(`/user-preferences/tabele/${encodeURIComponent(ekran)}`, { ukryteKolumny }),
};

export default uiPreferencesApi;
